export const style = {
    mainWrapper: {py: 2, textAlign: "center"},
    title: {my: 2, fontSize: 20, fontWeight: 600},
    locationTypo: {my: 2, fontSize: 15},
    textTimeAndDate: { width: "100%", textAlign: "center", my: 2 },
    button: {
        my: 2,
        width: '100%',
        borderRadius: '20px',
        backgroundColor: 'rgb(180, 199, 74)',
        color: 'white',
        border: 'rgb(180, 199, 74)',
    }
}
